export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export const categories: Category[] = [
  {
    slug: 'gonglue',
    name: '攻略指南',
    description: '最全的重生萝莉岛攻略，从新手入门到高手进阶，手把手教你玩转神秘岛屿。',
    icon: 'ri-book-open-line',
    color: 'primary',
  },
  {
    slug: 'juqing',
    name: '剧情解析',
    description: '深度解析重生萝莉岛的奇幻剧情，揭开岛屿背后的秘密与每一个动人的故事。',
    icon: 'ri-file-text-line',
    color: 'accent',
  },
  {
    slug: 'jiaose',
    name: '角色图鉴',
    description: '全面介绍重生萝莉岛中的萌系角色，了解她们的背景故事与独特技能。',
    icon: 'ri-user-heart-line',
    color: 'secondary',
  },
  {
    slug: 'maoxian',
    name: '冒险日志',
    description: '记录重生萝莉岛上每一次精彩的冒险旅程，分享探索过程中的惊喜与发现。',
    icon: 'ri-compass-3-line',
    color: 'primary',
  },
  {
    slug: 'qihuan',
    name: '奇幻设定',
    description: '探索重生萝莉岛的奇幻世界观设定，了解岛屿的魔法体系与独特规则。',
    icon: 'ri-magic-line',
    color: 'accent',
  },
];